module.exports = __webpack_public_path__ + "static/media/404.dc27ae3c.png";